import { LabelRegular, View } from 'smoothie';

interface ErrorWidgetProps {
    message?: string;
}

const ErrorWidget = ({ message }: ErrorWidgetProps) => {
    return (
        <View
            justifyContent="center"
            padding={16}
            height={48}
            marginVertical={16}
            borderRadius={12}
            backgroundColor="$white"
        >
            <LabelRegular color="$red1100">
                {message ?? 'Oops! Something went wrong.'}
            </LabelRegular>
        </View>
    );
};

export default ErrorWidget;
